import { SET_USERS_DATA, SET_PROMO_DATA } from "../actions/action";
import { SET_COUNTRY_CODE } from "../actions/action";
import { SET_MENU_DATA } from "../actions/action";
import { SET_LOCATION_DATA } from "../actions/action";


const initialState = {
  usersData: [],
  promoData: [],
  locationData: [],
  countryCodeData: [],
  menudata: [],
};

 const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USERS_DATA:
      return {
        ...state,
        usersData: action.payload.usersData,
      };
      case SET_PROMO_DATA:
      return {
        ...state,
        promoData: action.payload.promoData,
      };
      case SET_LOCATION_DATA:
      return {
        ...state,
        locationData: action.payload.locationData,
      };
      case SET_COUNTRY_CODE:
        return {
          ...state,
          countryCodeData: action.payload.countryCodeData,
        };
        case SET_MENU_DATA:
          return {
            ...state,
            menudata: action.payload.menudata,
          };
    default:
      return state;
  }
};

export default usersReducer;
